module.exports = __webpack_public_path__ + "assets/photos/memories/frame-3-mobile--59740c1d429b3604dc5db8b2662bbaf4.jpg";